<script>
export default {
    name: "GatePassReport",

    data() {

        return {
            patients: [],
        };
    },

    mounted() {

        Promise.allSettled([ this.fetchPatients(), ]).then(() => { 
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchPatients() {
            let url = `Admissions/GetGatePassPatientsforDateWard`;
                url += `?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;
                url += this.$route.query.ward ? `&Ward=${this.$route.query.ward}` : ``;

            return this.$http.get(url).then(response => {
                    this.patients = response.data;
                }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="w-full my-2 text-center">
            <h5 class="font-medium">Gatepass Report</h5>
        </div>
            <table class="table table-striped">
                <thead class="text-sm">
                      <tr class="w-full flex">
                          <th class="p-tiny w-1/6">Patient</th>
                          <th class="p-tiny w-1/12">IPFile No</th>
                          <th class="p-tiny w-1/12">Ward Type</th>
                          <th class="p-tiny w-1/12">Admitted</th>
                          <th class="p-tiny w-1/12">Discharged</th>
                          <th class="p-tiny w-1/12">Ward</th>
                          <th class="p-tiny w-1/12">Bed</th>
                          <th class="p-tiny w-1/12">Days</th>
                          <th class="p-tiny w-1/12">Approved By</th>
                          <th class="p-tiny w-1/6">PMode</th>
                      </tr>
                </thead>
                <tbody class="text-xs flex flex-col items-center">
                    <tr class="w-full flex" v-for="(patient, idx) in patients" :key="idx">
                        <td class="p-tiny w-1/6">{{ patient.names }}</td>
                        <td class="p-tiny w-1/12">{{ patient.ipfileno }}</td>
                        <td class="p-tiny w-1/12">{{ patient.type }}</td>
                        <td class="p-tiny w-1/12">{{ patient.dateAdmitted | dateFormat }}</td>
                        <td class="p-tiny w-1/12">{{ patient.discharged ? `Yes` : `No` }}</td>
                        <td class="p-tiny w-1/12">{{ patient.ward }}</td>
                        <td class="p-tiny w-1/12">{{ patient.bed }}</td>
                        <td class="p-tiny w-1/12">{{ patient.days }}</td>
                        <td class="p-tiny w-1/12">{{ patient.approvedBy }}</td>
                        <td class="p-tiny w-1/6">{{ patient.pmode }}</td>
                    </tr>
                    <tr class="w-full flex">
                        <td class="w-1/2 p-tiny"></td>
                        <td class="w-1/2 p-tiny text-right">Total Patients: {{ patients.length }}</td>
                    </tr>
                </tbody>
            </table>
    </div>
</template>